import { routeHead } from "@/lib/routeHead";
import { META_DESCRIPTIONS } from "@/lib/metaDescriptions";
import { createFileRoute } from "@tanstack/react-router";
import InterimManagement from "@/pages/InterimManagement";

export const Route = createFileRoute("/interim-management")({
  head: () => routeHead('Interim Management — AGAPE', META_DESCRIPTIONS.interim.en, '/interim-management'),
  component: InterimManagement,
});
